var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyCheck2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99967 14.6668C11.6816 14.6668 14.6663 11.6821 14.6663 8.00016C14.6663 4.31826 11.6816 1.3335 7.99967 1.3335C4.31778 1.3335 1.33301 4.31826 1.33301 8.00016C1.33301 11.6821 4.31778 14.6668 7.99967 14.6668ZM11.0889 6.92275C11.4144 6.59731 11.4144 6.06968 11.0889 5.74424C10.7635 5.4188 10.2359 5.4188 9.91042 5.74424L7.16634 8.48832L6.08893 7.41091C5.76349 7.08547 5.23586 7.08547 4.91042 7.41091C4.58498 7.73634 4.58498 8.26398 4.91042 8.58942L6.57709 10.2561C6.90252 10.5815 7.43016 10.5815 7.7556 10.2561L11.0889 6.92275Z",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyCheck2);
export default __webpack_public_path__ + "static/media/grey-check-2.aeb9ccf2af104949a48719e3bb2c593f.svg";
export { ForwardRef as ReactComponent };